import { createFileRoute } from "@tanstack/react-router";
import ProcureIntegrations from "lib/components/procure/ProcureIntegrations";
import getPageTitle from "lib/utils/getPageTitle";
import { Helmet as Head } from "react-helmet-async";
import withAuthentication from "../../../../../components/withAuthentication";

function ProcureCustomFieldsPage() {
  return (
    <>
      <Head>
        <title>{getPageTitle("Estimate: Custom Fields")}</title>
      </Head>
      <ProcureIntegrations path="customfields" />
    </>
  );
}

export const Route = createFileRoute("/builders/$builder_id/estimate/integrations/customfields")({
  component: withAuthentication(ProcureCustomFieldsPage, { products: ["procure"] }),
});
